module.exports = __webpack_public_path__ + "media/images/courses/add-course-46729b64c174446e2a459c7b8c010502.png";